import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-busqueda-paginador',
  standalone: true,
  imports: [CommonModule, FormsModule, ButtonModule, DropdownModule, TooltipModule],
  template: `
    <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2 p-3 border-t">
      <div class="text-gray-600 text-sm">
        Página {{ currentPage() }}@if (totalPages() > 0) { de {{ totalPages() }} }
      </div>
      <div class="flex flex-wrap gap-2 items-center">
        <label class="text-sm text-gray-600">Registros:</label>
        <p-dropdown
          [options]="pageSizeOptions()"
          [ngModel]="selectedPageSize()"
          (onChange)="emitPageSize($event)"
          appendTo="body"
          styleClass="w-full sm:w-24 max-w-full"
        >
        </p-dropdown>
        <button
          pButton
          icon="pi pi-angle-double-left"
          class="p-button-outlined p-button-sm min-w-[44px] min-h-[44px]"
          pTooltip="Primera página"
          [disabled]="currentPage() <= 1"
          (click)="first.emit()"
        ></button>
        <button
          pButton
          icon="pi pi-angle-left"
          class="p-button-outlined p-button-sm min-w-[44px] min-h-[44px]"
          pTooltip="Anterior"
          [disabled]="!hasPrevious()"
          (click)="previous.emit()"
        ></button>
        <button
          pButton
          icon="pi pi-angle-right"
          class="p-button-outlined p-button-sm min-w-[44px] min-h-[44px]"
          pTooltip="Siguiente"
          [disabled]="!hasNext()"
          (click)="next.emit()"
        ></button>
        <button
          pButton
          icon="pi pi-angle-double-right"
          class="p-button-outlined p-button-sm min-w-[44px] min-h-[44px]"
          pTooltip="Última página"
          [disabled]="currentPage() >= totalPages()"
          (click)="last.emit()"
        ></button>
      </div>
    </div>
  `
})
export class BusquedaPaginadorComponent {
  currentPage = input.required<number>();
  totalPages = input.required<number>();
  hasPrevious = input.required<boolean>();
  hasNext = input.required<boolean>();
  pageSizeOptions = input.required<number[]>();
  selectedPageSize = input.required<number>();

  pageSizeChange = output<number>();
  first = output<void>();
  previous = output<void>();
  next = output<void>();
  last = output<void>();

  emitPageSize(event: { value?: number }): void {
    this.pageSizeChange.emit(event.value ?? this.selectedPageSize());
  }
}
